// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/components/assets/fonts/og-var.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.container {
    flex:1 1;
    display: flex;
    overflow: hidden;
}

.center-container{
    display: flex;
    align-items: center;
    justify-content: center;
}

.table {
    flex : 2 1;
    display: 'flex';
    overflow-y: auto;
    height: 100%;
    overflow-x: hidden;
    max-width: 100%;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE */ 
    
}

.table::-webkit-scrollbar {
    display: none;
}

@font-face {
    font-family: "Overused Grotesk";
  
    font-style: normal;
  
    font-display: swap;
  
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  }
  
  * {
    font-family: "Overused Grotesk", sans-serif !important;
}
  
body {
    font-family: "Overused Grotesk";
    font-size: 11pt;
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow-y:auto; 
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE */
    margin-top: 0px;
    margin-bottom: 0px;
    background-color:#F8F9FF;
    ;
}

body::-webkit-scrollbar {
    display: none;
    scrollbar-color: "#E2E5F9";

}

.sidebar {
    flex: 0 0 auto;
    overflow-y: auto;
    margin-left: 3px;
    margin-bottom: 10px;
    border-right: 1px solid #CCC;
    overflow: hidden;
}

/* chrome, safari, opera */
.sidebar::-webkit-scrollbar {
    width: 4px;
    height: 0px;
}

.sidebar:hover {
    overflow: auto;
}

.sidebar::-webkit-scrollbar-thumb {
    background: #6E6E6E;
}

.navbar:hover {
    color: #0C73EB;
}

.filterbutton:hover {
    text-decoration: line-through;
}

.customScrollbar {
    overflow: hidden;
}

.customScrollbar:hover {
    overflow: auto;
}

.customScrollbar::-webkit-scrollbar {
    width: 5px;
    height: 0px;
}

.customScrollbar::-webkit-scrollbar-thumb {
    background: #6E6E6E; /*darkgrey, BDBDBD*/
}

.customScrollbar:hover::-webkit-scrollbar {
    height: 5px;
}

.metadata {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 85px;
    padding-top: 20px;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE */ 
}

.metadata::-webkit-scrollbar {
  display: none;
}
/* General Scrollbar Styling */
::-webkit-scrollbar {
    width: 4px; /* Smaller width */
}

::-webkit-scrollbar-thumb {
    background: #E2E5F9; /* Light blue color */
    border-radius: 40px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

/* Sidebar Scrollbar */
.sidebar::-webkit-scrollbar {
    width: 4px;
}

.sidebar::-webkit-scrollbar-thumb {
    background: #E2E5F9;
}

/* Custom Scrollbar */
.customScrollbar::-webkit-scrollbar {
    width: 4px;
}

.customScrollbar::-webkit-scrollbar-thumb {
    background: #E2E5F9;
}

/* Metadata Section Scrollbar */
.metadata::-webkit-scrollbar {
    width: 4px;
}

.metadata::-webkit-scrollbar-thumb {
    background: #E2E5F9;
}

/* Firefox and IE */
* {
    scrollbar-width: thin;
    scrollbar-color: #E2E5F9 transparent;
}

  input {
    border: 2px solid #364098 ;
  }
  .custom-input {
    border: 2px solid #CCCFEA;
    border-radius: 2vw;
    overflow: hidden;
}

@media (min-width: 768px) {
    .custom-input {
        border-radius: 0.5vw;
    }
}

.custom-input:focus-within {
    border-color: #364098;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,QAAM;IACN,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,OAAO;;AAErC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;;IAE/B,kBAAkB;;IAElB,kBAAkB;;IAElB,+DAAwE;EAC1E;;EAEA;IACE,sDAAsD;AAC1D;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,OAAO;IACjC,eAAe;IACf,kBAAkB;IAClB,wBAAwB;;AAE5B;;AAEA;IACI,aAAa;IACb,0BAA0B;;AAE9B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB,EAAE,mBAAmB;AAC5C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,OAAO;AACrC;;AAEA;EACE,aAAa;AACf;AACA,8BAA8B;AAC9B;IACI,UAAU,EAAE,kBAAkB;AAClC;;AAEA;IACI,mBAAmB,EAAE,qBAAqB;IAC1C,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;EAEE;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".app {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n}\n\n.container {\n    flex:1;\n    display: flex;\n    overflow: hidden;\n}\n\n.center-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.table {\n    flex : 2;\n    display: 'flex';\n    overflow-y: auto;\n    height: 100%;\n    overflow-x: hidden;\n    max-width: 100%;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE */ \n    \n}\n\n.table::-webkit-scrollbar {\n    display: none;\n}\n\n@font-face {\n    font-family: \"Overused Grotesk\";\n  \n    font-style: normal;\n  \n    font-display: swap;\n  \n    src: url(\"../src/components/assets/fonts/og-var.ttf\") format(\"truetype\");\n  }\n  \n  * {\n    font-family: \"Overused Grotesk\", sans-serif !important;\n}\n  \nbody {\n    font-family: \"Overused Grotesk\";\n    font-size: 11pt;\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    overflow-y:auto; \n    overflow-x: hidden;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE */\n    margin-top: 0px;\n    margin-bottom: 0px;\n    background-color:#F8F9FF;\n    ;\n}\n\nbody::-webkit-scrollbar {\n    display: none;\n    scrollbar-color: \"#E2E5F9\";\n\n}\n\n.sidebar {\n    flex: 0 0 auto;\n    overflow-y: auto;\n    margin-left: 3px;\n    margin-bottom: 10px;\n    border-right: 1px solid #CCC;\n    overflow: hidden;\n}\n\n/* chrome, safari, opera */\n.sidebar::-webkit-scrollbar {\n    width: 4px;\n    height: 0px;\n}\n\n.sidebar:hover {\n    overflow: auto;\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n    background: #6E6E6E;\n}\n\n.navbar:hover {\n    color: #0C73EB;\n}\n\n.filterbutton:hover {\n    text-decoration: line-through;\n}\n\n.customScrollbar {\n    overflow: hidden;\n}\n\n.customScrollbar:hover {\n    overflow: auto;\n}\n\n.customScrollbar::-webkit-scrollbar {\n    width: 5px;\n    height: 0px;\n}\n\n.customScrollbar::-webkit-scrollbar-thumb {\n    background: #6E6E6E; /*darkgrey, BDBDBD*/\n}\n\n.customScrollbar:hover::-webkit-scrollbar {\n    height: 5px;\n}\n\n.metadata {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-bottom: 85px;\n    padding-top: 20px;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE */ \n}\n\n.metadata::-webkit-scrollbar {\n  display: none;\n}\n/* General Scrollbar Styling */\n::-webkit-scrollbar {\n    width: 4px; /* Smaller width */\n}\n\n::-webkit-scrollbar-thumb {\n    background: #E2E5F9; /* Light blue color */\n    border-radius: 40px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n/* Sidebar Scrollbar */\n.sidebar::-webkit-scrollbar {\n    width: 4px;\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n    background: #E2E5F9;\n}\n\n/* Custom Scrollbar */\n.customScrollbar::-webkit-scrollbar {\n    width: 4px;\n}\n\n.customScrollbar::-webkit-scrollbar-thumb {\n    background: #E2E5F9;\n}\n\n/* Metadata Section Scrollbar */\n.metadata::-webkit-scrollbar {\n    width: 4px;\n}\n\n.metadata::-webkit-scrollbar-thumb {\n    background: #E2E5F9;\n}\n\n/* Firefox and IE */\n* {\n    scrollbar-width: thin;\n    scrollbar-color: #E2E5F9 transparent;\n}\n\n  input {\n    border: 2px solid #364098 ;\n  }\n  .custom-input {\n    border: 2px solid #CCCFEA;\n    border-radius: 2vw;\n    overflow: hidden;\n}\n\n@media (min-width: 768px) {\n    .custom-input {\n        border-radius: 0.5vw;\n    }\n}\n\n.custom-input:focus-within {\n    border-color: #364098;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
